import { ImageAnnotator } from './annotator';
import { Shape, Polygon, Rectangle, Circle, Point, Ellipse, Dot } from 'image-labeling';
import { useImageAnnotator } from './annotator/hook';
export { ImageAnnotator, Shape, Polygon, Rectangle, Circle, Point, Ellipse, Dot, useImageAnnotator }
